<template>
  <Primitive
    class="flex items-center py-4 ltr:pr-5 rtl:pl-5 ltr:pl-3 rtl:pr-3 md:py-3 gap-5 md:gap-3 bg-white hover:bg-primary_hover md:rounded-xl md:shadow-xs hover:shadow-none cursor-pointer"
    :as="as"
  >
    <div class="flex items-center grow gap-4 md:gap-3">
      <div
        class="flex items-center p-2.5 md:p-2 text-utility-gray-500 bg-utility-gray-100 rounded-full [&_svg]:w-5 [&_svg]:h-5 [&_svg]:md:w-4 [&_svg]:md:h-4 [&_svg]:shrink-0"
      >
        <Icon :name="icon || 'chat'" class="icon" />
      </div>

      <div class="flex flex-col justify-center grow">
        <div class="text-primary text-style-base font-medium line-clamp-2">
          {{ title }}
        </div>
        <div>
          <span
            class="text-tertiary text-style-sm font-medium block md:inline-block md:ltr:pr-2 md:rtl:pl-2"
          >
            <slot />
          </span>
          <span
            v-if="date"
            class="text-quaternary text-style-xs text-right block md:inline-block shrink-0 whitespace-nowrap"
          >
            <TimeAgo relative :date="date" />
          </span>
        </div>
      </div>
    </div>

    <Dot
      :variant="read ? 'read' : 'unread'"
      :size="maxSmall ? 'lg' : 'md'"
      class="shrink-0"
    />
  </Primitive>
</template>

<script setup>
import { Primitive } from "radix-vue";
import { TimeAgo } from "@/SharedComponents/Date";
import { Dot } from "@/SharedComponents/Dots";
import { Icon } from "@/SharedComponents/Icon";

import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineProps({
  as: { type: String, default: "div" },
  icon: { type: String, required: false },
  title: { type: String, required: true },
  date: { type: Date, required: false },
  read: { type: Boolean, required: false, default: false },
});
</script>
